export default __webpack_public_path__ + "static/media/ec.ae28d58e.svg";